import React from "react";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import HomePage from "./pages/Home/HomePage";

const Router: React.FC = () => {
  return (
    <BrowserRouter>
      <Routes>
        <Route
          path="/:bussinessName/paymentLink/:paymentLink"
          element={<HomePage />}
        />
      </Routes>
    </BrowserRouter>
  );
};

export default Router;
